module.exports = __webpack_public_path__ + "static/adelle_light-webfont-woff-ee0649fa6b7c4f1303dc8ecaa576895d.woff";